// §18.1 component inventory: "EmptyState — icon, one sentence, one primary action."
// Single implementation, reused everywhere a list/screen has nothing to show yet.
import type { LucideIcon } from 'lucide-react';

export function EmptyState({
  icon: IconComponent,
  message,
  action,
}: {
  icon: LucideIcon;
  message: string;
  action?: { label: string; onClick: () => void };
}): React.JSX.Element {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-3 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
        <IconComponent size={22} />
      </div>
      <p className="max-w-xs text-sm text-muted">{message}</p>
      {action !== undefined && (
        <button
          type="button"
          onClick={action.onClick}
          className="rounded-[var(--radius-control)] bg-primary px-3 py-1.5 text-sm font-medium text-primary-ink hover:opacity-90 active:opacity-80"
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
